import React from "react";
import { createRoot } from "react-dom/client";
import { ReplayWidget } from "./ReplayWidget";
import "./styles/replay.css";

interface MountOptions {
  selector?: string;
}

function mount(options: MountOptions = {}): (() => void) | undefined {
  const selector = options.selector ?? "#githits-replay";
  const container = document.querySelector(selector);
  if (!container) {
    console.warn(`[githits-replay] Container "${selector}" not found`);
    return undefined;
  }

  // Guard against double-mounting on the same container
  if (container.hasAttribute("data-githits-mounted")) {
    console.warn(`[githits-replay] Container "${selector}" already mounted`);
    return undefined;
  }
  container.setAttribute("data-githits-mounted", "true");

  // Add the scoping class for Tailwind styles
  container.classList.add("githits-replay");

  const root = createRoot(container);
  root.render(React.createElement(ReplayWidget));

  // Return an unmount function for cleanup
  return () => {
    root.unmount();
    container.removeAttribute("data-githits-mounted");
    container.classList.remove("githits-replay");
  };
}

// Auto-mount on DOMContentLoaded
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => mount());
} else {
  mount();
}

// Expose for manual mounting
declare global {
  interface Window {
    GithitsReplay?: { mount: typeof mount };
  }
}
window.GithitsReplay = { mount };
